import React from 'react';
import PropTypes from 'prop-types';
import { Box, Text, Heading, Icon } from 'roo-ui/components';
import TextButton from 'components/TextButton';

const LoadingError = ({ reload }) => (
  <Box p={6} border={1} borderColor="ui.error">
    <Icon name="warning" size={26} mr={2} color="ui.error" /> <Heading.h3 display="inline">Sorry, something went wrong.</Heading.h3>
    <Box mb={6} pt={4}>
      <Text>We&apos;re having trouble loading the credit card form.</Text>
      <Text>To continue with your booking, try reloading the form. Your booking progress won&apos;t be lost.</Text>
    </Box>
    <TextButton onClick={reload} variant="primary" data-testid="reload-button">
      Try again
    </TextButton>
  </Box>
);

LoadingError.propTypes = {
  reload: PropTypes.func.isRequired,
};

export default LoadingError;
